export { default } from "./BottomNavigation.mjs";
export { default as bottomNavigationClasses } from "./bottomNavigationClasses.mjs";
export * from "./bottomNavigationClasses.mjs";